import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Title = styled.h2`
  font-weight: 500;
  font-size: 0.875em;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
`;

export const SubTitle = styled.h3`
  font-weight: 400;
  font-size: 0.75em;
  line-height: 16px;
  color: ${Palette.PrimaryGray._500};
`;

export const TextField = styled.div`
  flex: 30%;
  align-self: ${({ position }) => position && 'center'};
  padding-top: 8px;
`;

export const ActionField = styled.div`
  background: ${Palette.PrimaryGray._000};
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
`;
export const Line = styled.div`
  background: ${Palette.PrimaryGray._200};
  height: 1px;
  width: 100%;
  margin-bottom: ${({ isNoButton }) => (isNoButton ? '12px' : '2px')};
`;

export const FieldsWrap = styled.div`
  flex: 70%;
  max-width: ${({ fullWidth }) => (fullWidth ? '100%' : '70%')};
`;

export const BtnWrap = styled.div`
  padding: 16px;
`;
export const SelectedItem = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  justify-items: stretch;
  grid-gap: 8px;
  padding: 4px 0 0;
  width: 100%;
  margin: 0;
`;

export const Wrap = styled.div`
  padding: 0 16px 16px 16px;
`;

export const Item = styled.li`
  width: calc(100% / 3 - 6px);
  //text-transform: capitalize;
  padding: 8px 10px 8px 8px;
  height: 32px;

  > :first-of-type p {
    font-weight: 500;
  }
  ${({ line }) =>
    line &&
    css`
      width: 100%;
      max-width: 100%;
    `}
  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `};
  display: flex;
  justify-content: space-between;
  align-items: center;
  list-style-type: none;
  border: 1px solid ${() => Palette.PrimaryGray._200};
  color: ${() => Palette.PrimaryGray._700};
  font-size: 0.75em;
  font-weight: 400;
  line-height: 16px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  background: #ffffff;
  &:hover {
    box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16);
    border: 1px solid ${() => Palette.Primary._300};
    outline: none;
    svg {
      cursor: pointer;
    }
  }
  svg {
    fill: ${() => Palette.PrimaryGray._400};
    &:active {
      fill: ${() => Palette.Primary._300};
    }
  }
  transition: all 0.2s linear;
`;

const packageAndIdCommonStyles = css`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._700};
  text-align: left;
`;

export const Id = styled.span`
  &::before {
    content: 'ID: ';
    color: ${Palette.PrimaryGray._500};
  }
  ${packageAndIdCommonStyles}
`;

export const Package = styled.span`
  ${packageAndIdCommonStyles}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 86%;
`;

export const IconWrapp = styled.div`
  display: flex;
  flex-basis: 1%;
`;

export const PackageNamesWrap = styled.div`
  background: ${Palette.PrimaryGray._000};
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
`;

export const PackageNamesActionField = styled.div``;

export const BtnWrapp = styled.div`
  width: 101px;
`;

export const ImgWrap = styled.div`
  width: 40px;
  height: 40px;
  display: block !important;
  img {
    display: block !important;
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
`;
